import React, { useEffect, useState } from 'react';
import { View } from 'react-native';
import styled from 'styled-components/native';

import { DatePicker, InputText } from '../core';
import { Bound } from 'opidcore';
import { BasicText, Heading2 } from '../Styles';

const TicketHeading = styled.View`
    margin-top: 10px;
    justify-content: space-between;
    flex-direction: row;
    flex-basis: 50px;
    width: 100%;
`;

const TicketSubHeading = styled.View`
    justify-content: space-between;
    flex-direction: row;
    flex-basis: 50px;
    width: 100%;
`;

const TicketBody = styled.View`
    justify-content: space-between;
    flex-direction: column;
    flex-basis: auto;
    width: 100%;
    border: 1px solid #cdcdcd;
    padding: 5px;
    border-radius: ${props => props.theme.rounded ? (props.theme.rounded * 4) + "px" : 0};
`;

const SupportView = ({ticket = undefined}) => {
    if(ticket == undefined){
        return <BasicText>Failed to load.</BasicText>
    }

    return <View>
        <Heading2>Service Request</Heading2>
        <View style={{flexDirection: "column", justifyContent: "space-between", alignItems: "center"}}>
            <Bound to={ticket}>
                <TicketHeading>
                    <InputText field="taskTypeObject.name" label="Type" readOnly={true}/>
                    <InputText field="status" label="Status" readOnly={true}/>
                    <DatePicker field="created" label="Date Sent" readOnly={true} dateFormat="YYYY-MM-DD HH:mm"/>
                </TicketHeading>
                <TicketSubHeading>
                    <InputText field="customer.name" label="Client" readOnly={true}/>
                    <InputText field="site.name" label="Site" readOnly={true}/>
                </TicketSubHeading>
                <TicketSubHeading>
                    <InputText field="subject" label="Description" readOnly={true}/>
                </TicketSubHeading>
                {ticket.body == undefined || ticket.body.trim().length <= 0 ? null :
                    <TicketBody>
                        <InputText field="body" readOnly={true} />
                    </TicketBody>
                }             
            </Bound>
        </View>
    </View>
}

export default SupportView;